module.exports = __webpack_public_path__ + "img/blueRight.e297da24.svg";